import Base from "./base";

export default class TurboYatirim extends Base {
	makeExternalPayment() {
		const { stake, selectedCurrency } = this.state;
		let withdrawData = {
			type: "TurboYatirim",
			processType: "papara",
			paymentType: "papara",
			amount: {
				value: stake,
				currency: selectedCurrency ? selectedCurrency : "TRY",
			},
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
